<template>
    <div class="sc01">
        <div class="tit_area">
            <h3><span class="tit-st"><b>실시간</b></span> 도시현황 
                <a :href="$_WC.cp + 'realtime'" class="btn-more">더보기</a>
                <a v-show="isMoving && !$_WC.isMobile && disasterText !== ''" class="btn-stop" @click.prevent="stopMarquee()">재생</a>
                <a v-show="!isMoving && !$_WC.isMobile && disasterText !== ''" class="btn-start" @click.prevent="stopMarquee()">재생</a>
            </h3>
            <div class="alm_wrap" v-if="disasterText !== ''">
                <p class="txt"><marquee ref="mvTxt" @click.prevent="stopMarquee()" style="cursor:pointer;" :scrollamount="scrollspeed">{{ disasterText }}</marquee></p><i class="ic_alm"></i>
            </div>
        </div>
        <div class="main-tab">
            <div class="tab">
                <button :class="['tablinks', selectedRealtimeTab === 'Safety' ? 'active': '']"
                        @click="selectRealtimeTab('Safety')">안전</button>
                <button :class="['tablinks', selectedRealtimeTab === 'Accident' ? 'active': '']"
                        @click="selectRealtimeTab('Accident')">도로</button>
                <button :class="['tablinks', selectedRealtimeTab === 'Air' ? 'active': '']"
                        @click="selectRealtimeTab('Air')">대기</button>
                <button :class="['tablinks', selectedRealtimeTab === 'Water' ? 'active': '']"
                        @click="selectRealtimeTab('Water')">상수도</button>
                <!-- <button :class="['tablinks', 'd4k-visible', selectedRealtimeTab === 'Covid' ? 'active': '']"
                        @click="selectRealtimeTab('Covid')">코로나19</button> -->
                <!-- <a href="https://www.gangnam.go.kr/covid.html" target="_blank" class="d4k-hidden">
                    <div class="covid-icon">
                        코로나19현황
                    </div>
                </a> -->
<!--                <a :href="$_WC.cp + 'realtime'" class="main_btn_more" v-show="$_WC.responsiveScale == 3">더보기</a>-->
            </div>
            <div class="tabcontent" v-show="selectedRealtimeTab === 'Safety'">
                <ul>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Safety'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof safetyMap[0] === $_TYPE.UNDEF ? 0 : safetyMap[0].length" />
                        </b>
                        <span>재난</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Safety'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof safetyMap[1] === $_TYPE.UNDEF ? 0 : safetyMap[1].length" />
                        </b>
                        <span>화재</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Safety'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof safetyMap[2] === $_TYPE.UNDEF ? 0 : safetyMap[2].length" />
                        </b>
                        <span>구조</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Safety'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof safetyMap[3] === $_TYPE.UNDEF ? 0 : safetyMap[3].length" />
                        </b>
                        <span>구급</span>
                    </li>
                </ul>
            </div>
            <div class="tabcontent" v-show="selectedRealtimeTab === 'Accident'">
                <ul>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Accident'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof accidentMap[1] === $_TYPE.UNDEF ? 0 : accidentMap[1].length" />
                        </b>
                        <span>사고</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Accident'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof accidentMap[2] === $_TYPE.UNDEF ? 0 : accidentMap[2].length" />
                        </b>
                        <span>공사</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Accident'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof accidentMap[3] === $_TYPE.UNDEF ? 0 : accidentMap[3].length" />
                        </b>
                        <span>행사</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Accident'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="typeof accidentMap[5] === $_TYPE.UNDEF ? 0 : accidentMap[5].length" />
                        </b>
                        <span>통제</span>
                    </li>
                </ul>
            </div>

            <div class="tabcontent" v-show="selectedRealtimeTab === 'Air'">
                <ul>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'pm10' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('pm10')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Air'"
                                                 :duration="animatedDuration" :formatValue="formatToInt"
                                                 :value="airSummaryMap.fineDustAvg" />
                            </b>
                            <span>미세먼지</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'pm25' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('pm25')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Air'"
                                                 :duration="animatedDuration" :formatValue="formatToInt"
                                                 :value="airSummaryMap.ultraFineDustAvg" />
                            </b>
                            <span>초미세먼지</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'no2' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('no2')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Air'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat3"
                                                 :value="airSummaryMap.no2" />
                            </b>
                            <span>이산화질소</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'rain' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('rain')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Air'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat1"
                                                 :value="rainfallVal" />
                            </b>
                            <span>강우량</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="tabcontent" v-show="selectedRealtimeTab === 'Water'">
                <ul>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'val7' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('val7')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Water'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat1"
                                                 :value="waterQualityMap.val7" />
                            </b>
                            <span>pH</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'val8' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('val8')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Water'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat2"
                                                 :value="waterQualityMap.val8" />
                            </b>
                            <span>잔류염소</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'val9' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('val9')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Water'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat2"
                                                 :value="waterQualityMap.val9" />
                            </b>
                            <span>탁도</span>
                        </a>
                    </li>
                    <li>
                        <a href="javascript: void(0);" :class="[selectedRealtimeSubTab === 'val10' ? 'on' : '']" @click.prevent="selectRealtimeSubTab('val10')">
                            <b class="item-num">
                                <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Water'"
                                                 :duration="animatedDuration" :formatValue="formatToFloat1"
                                                 :value="waterQualityMap.val10" />
                            </b>
                            <span>수온</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="tabcontent covid" v-show="selectedRealtimeTab === 'Covid'">
                <ul>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidConfirmCnt" />
                        </b>
                        <span>신규확진자</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidIsolateCnt" />
                        </b>
                        <span>누적자가격리자</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidTestCnt" />
                        </b>
                        <span>누적검사건수</span>
                    </li>
                    <!--
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidConfirmCnt1" />
                        </b>
                        <span>신규확진자</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidConfirmCnt2" />
                        </b>
                        <span>서울시 신규확진자</span>
                    </li>
                    <li>
                        <b class="item-num">
                            <animated-number style="all: inherit;" v-if="selectedRealtimeTab === 'Covid'"
                                             :duration="animatedDuration" :formatValue="formatToInt"
                                             :value="covidConfirmCnt3" />
                        </b>
                        <span>서울시 누적확진자</span>
                    </li>
                    -->
                </ul>
            </div>
        </div>

        <!-- <SafetyList v-if="selectedRealtimeTab === 'Safety'" />
        <AccidentList v-if="selectedRealtimeTab === 'Accident'" />
        <AirList v-if="selectedRealtimeTab === 'Air'" />
        <WaterList v-if="selectedRealtimeTab === 'Water'" />
        <CovidList v-if="selectedRealtimeTab === 'Covid'" /> -->

        <MainRealtimeChart />
    </div>
</template>

<script>

import gripUtil from "@/libs/grip.util";
import { $_WC, $_TYPE } from '@/confs/common.const.js';
import {mapGetters} from "vuex";
import SafetyList from '@/views/main/SafetyList.vue';
import AccidentList from '@/views/main/AccidentList.vue';
import AirList from '@/views/main/AirList.vue';
import WaterList from '@/views/main/WaterList.vue';
import CovidList from '@/views/main/CovidList.vue';
import AnimatedNumber from "animated-number-vue";
import MainRealtimeChart from "@/views/main/MainRealtimeChart.vue";

export default {
    name: 'RealtimeTab',
    components: {
        SafetyList,
        AccidentList,
        AirList,
        WaterList,
        CovidList,
        AnimatedNumber,
        MainRealtimeChart,
    },
    data(){
        return {
            playPhaseNomal: [
                {top: 'Safety', sub: ''},
                {top: 'Accident', sub: ''},
                // {top: 'Air', sub: 'pm10'},
                // {top: 'Air', sub: 'pm25'},
                // {top: 'Air', sub: 'decibel'},
                // {top: 'Air', sub: 'rain'},
                {top: 'Water', sub: 'val7'},
                {top: 'Water', sub: 'val8'},
                {top: 'Water', sub: 'val9'},
                {top: 'Water', sub: 'val10'},
            ],
            playPhase4k: [
                {top: 'Safety', sub: ''},
                {top: 'Accident', sub: ''},
                // {top: 'Air', sub: 'pm10'},
                // {top: 'Air', sub: 'pm25'},
                // {top: 'Air', sub: 'decibel'},
                // {top: 'Air', sub: 'rain'},
                {top: 'Water', sub: 'val7'},
                {top: 'Water', sub: 'val8'},
                {top: 'Water', sub: 'val9'},
                {top: 'Water', sub: 'val10'},
                // {top: 'Covid', sub: ''},
            ],
            currentPhase: -1,
            intervalSec: 10,	// 10초 간격 롤링
            interval: undefined,
            isNew: true,
            animatedDuration: 500,
            // 재난문자 재생상태
            isMoving: true,
            scrollspeed: $_WC.viewScale > 1 ? 6 : 3,
        };
    },
    created(){
        this.$eventBus.$on("SimpleMap::completed-simple-map-draw", (gripSimpleMap)=>{
            if(this.isNew){
                this.togglePlay();
                this.isNew = false;
            }
        });
        this.$eventBus.$on("LiveTab:stop-livetab-phase", ()=>{
            this.currentPhase = -1;
            this.stopPhase();
        });
    },
    computed: {
        ...mapGetters({
            selectedRealtimeTab: 'getSelectedRealtimeTab',
            selectedRealtimeSubTab: 'getSelectedRealtimeSubTab',
            safetyList: 'getSafetyList',
            accidentList: 'getAccidentList',
            airSpace: 'getAirSpace',
            airHjdSensorList: 'getAirHjdSensorList',
            rainfallList: 'getRainfallList',
            dongRainfallInfo: 'getDongRainfallInfo',
            waterQualityList: 'getWaterQualityList',
            isLivetabPlaying: 'getIsLivetabPlaying',
            covidSeoul: 'getCovidSeoul',
            covidGangnamList: 'getCovidGangnamList',
            covidIsolationList: 'getCovidIsolationList',
            covidCheckupLocList: 'getCovidCheckupLocList',
            covidSeoulList: 'getCovidSeoulList',
            covidDaySeoulList: 'getCovidDaySeoulList',
            disasterTxt: 'getDisasterTxt',
        }),
        playPhase(){
            if($_WC.viewScale === 2){
                return this.playPhase4k;
            } else {
                return this.playPhaseNomal;
            }
        },
        safetyMap(){
            return gripUtil.toMap(this.safetyList, 'safetyCategoryCd');
        },
        accidentMap(){
            return gripUtil.toMap(this.accidentList, 'val2');
        },
        airSummaryMap(){
            let airSummaryMap = {fineDustAvg: 0, ultraFineDustAvg: 0, decibelAvg: 0};
            this.airHjdSensorList.forEach((sensor)=>{
                // let dustAvg = isNaN(sensor.fineDustAvg) ? Number(0) : Number(sensor.fineDustAvg);
                // let ultraFineDustAvg = isNaN(sensor.ultraFineDustAvg) ? Number(0) : Number(sensor.ultraFineDustAvg);
                // let decibelAvg = isNaN(sensor.decibelAvg) ? Number(0) : Number(sensor.decibelAvg);

                // airSummaryMap.fineDustAvg += dustAvg;
                // airSummaryMap.ultraFineDustAvg += ultraFineDustAvg;
                // airSummaryMap.decibelAvg += decibelAvg;

                airSummaryMap.fineDustAvg = sensor.fineDust;
                airSummaryMap.ultraFineDustAvg = sensor.ultraFineDust;
                airSummaryMap.no2 = sensor.no2;

                // airSummaryMap.fineDustAvg += Number(sensor.fineDustAvg);
                // airSummaryMap.ultraFineDustAvg += Number(sensor.ultraFineDustAvg);
                // airSummaryMap.decibelAvg += Number(sensor.decibelAvg);
            });
            // airSummaryMap.fineDustAvg = Math.round(airSummaryMap.fineDustAvg / this.airHjdSensorList.length);
            // airSummaryMap.ultraFineDustAvg = Math.round(airSummaryMap.ultraFineDustAvg / this.airHjdSensorList.length);
            // airSummaryMap.decibelAvg = Math.round(airSummaryMap.decibelAvg / this.airHjdSensorList.length);

            return airSummaryMap;
        },
        rainfallVal(){
            let val = 0;
            let cnt = Object.keys(this.dongRainfallInfo).length;
            if(cnt > 0) {
                for(let name in this.dongRainfallInfo) {
                    val += Number(this.dongRainfallInfo[name].threeHourSum);
                }
                val = val / cnt;
            }
            return val.toFixed(1);
        },
        waterQualityMap(){
            let waterQualityMap = {
                val7: 0, val8: 0, val9: 0, val10: 0,
            };
            this.waterQualityList.forEach((waterQuality)=>{
                waterQualityMap.val7 += Number(waterQuality.val7);
                waterQualityMap.val8 += Number(waterQuality.val8);
                waterQualityMap.val9 += Number(waterQuality.val9);
                waterQualityMap.val10 += Number(waterQuality.val10);
            });
            waterQualityMap.val7 = Math.round(waterQualityMap.val7 / this.waterQualityList.length * 10) / 10;
            waterQualityMap.val8 = Math.round(waterQualityMap.val8 / this.waterQualityList.length * 100) / 100;
            waterQualityMap.val9 = Math.round(waterQualityMap.val9 / this.waterQualityList.length * 100) / 100;
            waterQualityMap.val10 = Math.round(waterQualityMap.val10 / this.waterQualityList.length * 10) / 10;
            return waterQualityMap;
        },
        covidGangnam(){
            let data = {};
            if(this.covidGangnamList.length > 0){
                data = this.covidGangnamList[0];
            }
            return data;
        },
        covidGangnamDateMap(){
            let map = {};
            this.covidGangnamList.forEach(d => {
                let key = d.basdtVal.substring(0, 8);
                if(typeof map[key] === $_TYPE.UNDEF){
                    map[key] = d;
                }
            });
            return map;
        },
        covidGangnamBefore(){
            let map = {};
            if(typeof this.covidGangnam.basdtVal !== $_TYPE.UNDEF && this.covidGangnam.basdtVal !== '') {
                let basdtVal = this.covidGangnam.basdtVal.substring(0, 4) + '-' + this.covidGangnam.basdtVal.substring(4, 6) + '-' + this.covidGangnam.basdtVal.substring(6, 8);

                let basday = new Date(basdtVal);
                let searchDay = new Date(basday - (3600000 * 24 * 1));
                let searchFromDate = searchDay.format('yyyyMMdd');

                if(typeof this.covidGangnamDateMap[searchFromDate] !== $_TYPE.UNDEF){
                    map = this.covidGangnamDateMap[searchFromDate];
                }
            }
            return map;
        },
        covidTempGangnamList() {
            let list = [];
            this.covidGangnamList.forEach(covid => {
                if (typeof this.confirmCnt(covid) !== $_TYPE.UNDEF) {
                    let map = {
                        confirm: this.confirmCnt(covid),
                    };
                    list.push(map);
                }
            });
            return list;
        },
        covidConfirmCnt(){
            if(this.covidTempGangnamList.length > 0) {
                return Number(this.covidTempGangnamList[0].confirm);
            }
        },
        covidIsolateCnt(){
            if(this.covidIsolationList.length > 0) {
                return Number(this.covidIsolationList[0].allCnt);
            }
        },
        covidTestCnt(){
            if(this.covidCheckupLocList.length > 0) {
                // return Number(this.covidCheckupLocList[0].val2) - Number(this.covidCheckupLocList[1].val2);
                return Number(this.covidCheckupLocList[0].val2);
            }
        },
        covidConfirmCnt1(){
            if(this.covidDaySeoulList.length > 0) {
                return Number(this.covidDaySeoulList[0].val27);
            }
        },
        covidConfirmCnt2(){
            if(this.covidDaySeoulList.length > 0) {
                return Number(this.covidDaySeoulList[0].val48);
            }
        },
        covidConfirmCnt3(){
            if(this.covidDaySeoulList.length > 0) {
                return Number(this.covidDaySeoulList[0].val6);
            }
        },
        disasterText() {
            let txt = '';
            if(this.disasterTxt.length > 0) {
                txt = this.disasterTxt[0].val3;
            }
            return txt;
        },
    },
    methods: {
        confirmCnt(covid){
            if(typeof covid.basdtVal !== $_TYPE.UNDEF && covid.basdtVal !== '') {
                let basdtVal = covid.basdtVal.substring(0, 4) + '-' + covid.basdtVal.substring(4, 6) + '-' + covid.basdtVal.substring(6, 8);
                let basday = new Date(basdtVal);
                let searchDay = new Date(basday - (3600000 * 24 * 1));
                let searchFromDate = searchDay.format('yyyyMMdd');

                if(typeof this.covidGangnamDateMap[searchFromDate] !== $_TYPE.UNDEF) {
                    return this.toNumber(Number(covid.val5) - Number(this.covidGangnamDateMap[searchFromDate].val5));
                }
            }
        },
        selectRealtimeTab(selectedRealtimeTab){
            // 심플맵 팝업창 닫기
            this.$eventBus.$emit("simple-map-popup-div-close");
            this.$eventBus.$emit("LiveTab:stop-livetab-phase");
            this.$store.dispatch('SET_SELECTED_REALTIME_TAB', selectedRealtimeTab);
            if(selectedRealtimeTab === 'Air') {
                this.$store.dispatch('SET_SELECTED_REALTIME_SUB_TAB', 'pm10');
            } else if(selectedRealtimeTab === 'Water') {
                this.$store.dispatch('SET_SELECTED_REALTIME_SUB_TAB', 'val7');
            }
        },
        selectRealtimeSubTab(selectedRealtimeSubTab){
            this.$eventBus.$emit("LiveTab:stop-livetab-phase");
            this.$store.dispatch('SET_SELECTED_REALTIME_SUB_TAB', selectedRealtimeSubTab);
        },
        stopPhase(){
            if(this.isLivetabPlaying) {
                if(typeof this.interval !== 'undefined') {
                    clearInterval(this.interval);
                    this.interval = undefined;
                }
                this.$store.dispatch('SET_IS_LIVETAB_PLAYING', false);

                // 60분 후 다시 play
                setTimeout(()=>{
                    if(!this.isPlaying) {
                        this.togglePlay();
                    }
                }, 1000 * 60 * 60);
            }
        },
        startPhase(){
            if(this.currentPhase === (this.playPhase.length - 1)) {
                this.currentPhase = 0;
            } else {
                this.currentPhase += 1;
            }
            let phase = this.playPhase[this.currentPhase];

            this.$store.dispatch('SET_SELECTED_REALTIME_TAB', phase.top);
            this.$store.dispatch('SET_SELECTED_REALTIME_SUB_TAB', phase.sub);
        },
        togglePlay(){
            if(!this.isLivetabPlaying) {
                this.startPhase();
                this.interval = setInterval(()=>{
                    this.startPhase();
                }, 1000 * this.intervalSec);
                this.$store.dispatch('SET_IS_LIVETAB_PLAYING', true);
            } else {
                this.stopPhase();
            }
        },
        toNumber(val){
            return gripUtil.toCurrency(val);
        },
        formatToInt(val){
            return this.toNumber(Number(val).toFixed(0));
        },
        formatToFloat1(val){
            return Number(val).toFixed(1);
        },
        formatToFloat2(val){
            return Number(val).toFixed(2);
        },
        formatToFloat3(val){
            return Number(val).toFixed(3);
        },
        stopMarquee() {
            let mvTxt = this.$refs.mvTxt;
            if(this.isMoving) {
                mvTxt.stop();
            } else {
                mvTxt.start();
            }
            this.isMoving = !this.isMoving;
        },
    },
};
</script>
<style>
</style>
